<template>
  <div>
    <div class="range" v-if="type === 'history'">
      <div class="data-field">
        <div class="label">{{ $t('provider.reservations.from') }}:</div>
        <datepicker class="datepicker" v-model="from" :format="calendarFormat"
          v-on:input="updateFrom"></datepicker>
      </div>
      <div class="data-field">
        <div class="label">{{ $t('provider.reservations.to') }}:</div>
        <datepicker class="datepicker" v-model="to" :format="calendarFormat"
        v-on:input="updateTo"></datepicker>
      </div>
      <div class="export-box no-label">
        <a class="button cta small success" @click="exportComplete">EXPORT</a>
      </div>
    </div>

    <table cellspacing="0" :class="[ 'trx-table', {'hideMobile':isMobile}]">
      <thead>
        <td>{{ $t('provider.reservations.id') }}</td>
        <td></td>
        <td>{{ $t('provider.reservations.pickupTime') }}</td>
        <td>{{ $t('provider.reservations.pickup') }}</td>
        <td>{{ $t('provider.reservations.dropoff') }}</td>
        <td>{{ $t('provider.reservations.service') }}</td>
        <td>{{ $t('provider.reservations.customer') }}</td>
        <td>{{ $t('provider.reservations.paxLuggage') }}</td>
        <td>{{ $t('provider.reservations.flight') }}</td>
        <td>{{ $t('provider.reservations.driverPayment') }}</td>
      </thead>
      <tbody>
        <tr v-for="rsvp in reservations" :class="rsvp.type">
          <td class="id">
            <a v-bind:href="'/#/reservation/' + rsvp.id" target="_blank"
              v-if="rsvp.type !== 'pkg'">
              {{ rsvp.id }}
            </a>
            <a v-bind:href="'/#/package/' + rsvp.id" target="_blank"
              v-if="rsvp.type === 'pkg'">
              {{ rsvp.id }}
            </a>
          </td>
          <td class="pkg">
            <a v-bind:href="'/#/package/' + rsvp.id" target="_blank"
              v-if="rsvp.type === 'pkg'">
              <i class="fa fa-cube"></i>
            </a>
          </td>
          <td class="date">{{ rsvp.pickupTime }}</td>
          <td class="pickup">{{ rsvp.pickup }}</td>
          <td class="dropoff">
            <span v-if="rsvp.isCharter">--</span>
            <span v-else>{{ rsvp.dropoff }}</span>
          </td>
          <td class="service">
            <span v-bind:class="['service-label', rsvp.service]" v-if="useOldQuatation">{{ serviceLabel(rsvp.service) }}</span>
            <span class="service-label" :style="{backgroundColor: rsvp.serviceType.color}" v-else>{{ rsvp.serviceType.label }}</span>
          </td>
          <td class="customer">{{ rsvp.customer }}</td>
          <td class="pax-luggage">{{ rsvp.pax + '/' + rsvp.luggage }}</td>
          <td class="flight">{{ rsvp.flight }}</td>
          <td class="flight">${{ toFixed(rsvp.amountPaid) }}</td>
        </tr>
        <tr v-show="loading">
          <td colspan="11" class="table-block">
            <ellipsis-loader></ellipsis-loader>
            {{ $t('provider.reservations.loading') }}
          </td>
        </tr>
        <tr v-show="reservations.length === 0 && !loading">
          <td colspan="11" class="table-block">
            <i class="fa fa-list-alt fa-2x"></i><br/>
            {{ $t('provider.reservations.emptyState.' + type) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div :class="[{'hideDesktop':!isMobile}, 'table-cards']">
      <div v-show="loading">
        <div class="table-block">
          <ellipsis-loader></ellipsis-loader>
          {{ $t('provider.reservations.loading') }}
        </div>
      </div>
      <div v-show="reservations.length === 0 && !loading">
        <div class="table-block">
          <i class="fa fa-list-alt fa-2x"></i><br/>
          {{ $t('provider.reservations.emptyState.' + type) }}
        </div>
      </div>
      <div class="table-card" v-for="(rsvp, index) in reservations" :key="index">
        <div class="card-header">
          <div class="service-div">
            <div>
              <a v-bind:href="'/#/reservation/' + rsvp.id" target="_blank"
                v-if="rsvp.type !== 'pkg'">
                {{ rsvp.id }}
              </a>
              <a v-bind:href="'/#/package/' + rsvp.id" target="_blank"
                v-if="rsvp.type === 'pkg'">
                {{ rsvp.id }}
              </a>
            </div>
            <div class="service">
              <span v-bind:class="['service-label', rsvp.service]" v-if="useOldQuatation">{{ serviceLabel(rsvp.service) }}</span>
              <span class="service-label" :style="{backgroundColor: rsvp.serviceType.color}" v-else>{{ rsvp.serviceType.label }}</span>
              <a v-bind:href="'/#/package/' + rsvp.id" target="_blank"
                v-if="rsvp.type === 'pkg'">
                <i class="fa fa-cube"></i>
              </a>
            </div>
          </div>
          <div class="amount">
            ${{ toFixed(rsvp.amountPaid) }}
          </div>
        </div>
        <div class="clock">
          <i class="fas fa-clock icon"></i>
          <span>
            {{ rsvp.pickupTime }}
          </span>
        </div>
        <div class="pickup">
          <i class="fas fa-map-marker-alt icon"></i>
          <span>{{rsvp.pickup}}</span>
        </div>

        <div class="dropoff">
          <i class="fas fa-location-arrow icon"></i>
          <span v-if="rsvp.isCharter">--</span>
          <span v-else>{{rsvp.dropoff}}</span>
        </div>

        <div class="flight">
          <i class="fas fa-plane-departure icon"></i>
          <span>{{ rsvp.flight }}</span>
        </div>

        <div>
          <i class="fas fa-user-friends icon"></i>
          {{ rsvp.pax }}
          <i class="fas fa-suitcase icon"></i>
          {{ rsvp.luggage }}
        </div>

        <div class="name">
          <i class="fas fa-user icon"></i>
          <span>{{rsvp.customer}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import services from '../../modules/api/services'
import ApiProvider from '../../modules/api/provider/reservations'
import CsvExport from 'csvexport'

export default {
  name: 'reservations',
  props: ['type', 'active'],
  components: { EllipsisLoader, datepicker },
  data () {
    return {
      loading: false,
      from: '',
      to: '',
      loaded: '',
      isMobile: false,
      total: {
        driverPayment: 0,
        fare: 0
      }
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    reservations () { return this.$store.state.provider[this.type] },
    useOldQuatation () { return CONFIG.useOldQuatation }
  },
  methods: {
    init () {
      if (this.active && this.loaded === this.provId) {
        return
      }
      this.loaded = this.provId
      let self = this
      self.from = moment().subtract(2, 'month').format('MM/DD/YYYY')
      if (self.type === 'history') {
        self.from = moment().subtract(7, 'days').format('MM/DD/YYYY')
      }
      self.to = moment().format('MM/DD/YYYY')
      self.$store.commit('provider/setFromTo', {
        type: self.type,
        from: self.from,
        to: self.to
      })

      self.$store.commit('provider/resetRsvp', self.type)
      self.$store.commit('provider/setCurrentPage', {
        type: self.type,
        page: 0
      })
      self.$store.commit('provider/setIsMax', {
        type: self.type,
        isMax: false
      })

      self.getReservations(true)
    },
    getReservations (refreshList) {
      let self = this
      if (self.loading) { return }

      if (refreshList) {
        self.$store.commit('provider/resetRsvp', self.type)
        self.$store.commit('provider/setIsMax', {
          type: self.type,
          isMax: false
        })
        self.$store.commit('provider/setCurrentPage', {
          type: self.type,
          page: 0
        })
        if (self.type === 'history') {
          self.$store.commit('provider/setTotalDriverPaymentLoading', {
            type: self.type,
            value: true
          })

          let totalPaymentData = {
            id: self.provId,
            type: self.type,
            since: moment(self.from, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            until: moment(self.to, 'MM/DD/YYYY').add(1, 'days').format('YYYY-MM-DD')
          }
          ApiProvider.getTotalPayment(self, totalPaymentData, function (res) {
            self.$store.commit('provider/setTotalDriverPaymentLoading', {
              type: self.type,
              value: false
            })
          })
        }
      }

      let params = {
        id: self.provId,
        type: self.type
      }

      self.loading = true
      ApiProvider.getRsvp(self, params, function (res) {
        self.loading = false
      })
    },
    calendarFormat (date) {
      return moment(date).format('MM/DD/YYYY');
    },
    updateFrom () {
      this.$store.commit('provider/setFromTo', {
        type: this.type,
        from: moment(this.from).format('MM/DD/YYYY'),
        to: this.to
      })

      this.getReservations(true)
    },
    updateTo () {
      this.$store.commit('provider/setFromTo', {
        type: this.type,
        from: this.from,
        to: moment(this.to).format('MM/DD/YYYY')
      })

      this.getReservations(true)
    },
    serviceLabel (code) { return services.getServiceName(code) },
    toFixed (value) { return parseFloat(value).toFixed(2) },
    setScreenSize() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    exportComplete () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: 'Loading please wait...'})

      self.total = {
        driverPayment: 0,
        fare: 0
      }
      
      let from = this.from ? moment(this.from).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      let to = this.to ? moment(this.to).add(1, 'days').format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD')
      self.$sdk.get(`/provider/${self.provId}/rsvp/history`, {
        token: self.$store.state.session.sessionToken,
        pickupSince: from,
        pickupUntil: to,
        pageNum: 1,
        pageSize: 99999
      }, res => {
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }

        if (!res.list.length) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Empty Result.'
          })
          return
        }

        let tmpData = []
        let rsvpIds = []
        res.list.forEach(rsvp => {
          tmpData.push(rsvp.type === 'rsvp' ? self.buildRsvp(rsvp.data) : self.buildPkg(rsvp.data))
          if (rsvp.type === 'rsvp') {
            rsvpIds.push(rsvp.data.ID)
          }
        })
        self.getSectorData(tmpData, rsvpIds)
      })
    },
    buildRsvp (data) {
      let pickup = data.pickupLocation.geofenceType === 'airport' ? data.pickupLocation.geofenceName : data.pickupLocation.title
      let dropoff = data.dropoffLocation.geofenceType === 'airport' ? data.dropoffLocation.geofenceName : data.dropoffLocation.title

      let customer = data.consumer.firstName + ' ' + data.consumer.lastName
      if (data.guest.firstName) {
        customer = data.guest.firstName + ' ' + data.guest.lastName
      }

      let flight = 'N/A'
      if (data.airline) { flight = data.airline + ' ' + data.flightNumber }
      if (!data.airline && data.dropoffAirline) { flight = data.dropoffAirline + ' ' + data.dropoffFlightNumber }

      let payment = data.payment
      let driverPayment = payment.amount + data.gasFee + payment.bonus + payment.tip + payment.pickupFee
      let fare = payment.fare + payment.airportFee + payment.bonus + payment.gasFee + payment.pickupFee + payment.tip + payment.travelInsurance - (payment.credits || 0)

      this.total.driverPayment += driverPayment
      this.total.fare += fare
      return {
        'ID': data.ID,
        'Pickup Date': moment(data.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
        'Pickup': pickup,
        'Pickup Sector': '',
        'Dropoff': dropoff,
        'Dropoff Sector': '',
        'Service': data.serviceType.code,
        'Customer': customer,
        'PAX / Luggage': `${data.passengers} / ${data.luggage}`,
        'Flight': flight,
        'Driver Payment': parseFloat(driverPayment.toFixed(2)),
        'Fare': parseFloat(fare.toFixed(2))
      }
    },
    buildPkg (data) {
      let customer = data.rsvp[0].consumer.firstName + ' ' + data.rsvp[0].consumer.lastName
      if (data.rsvp[0].guest.firstName) {
        customer = data.rsvp[0].guest.firstName + ' ' + data.rsvp[0].guest.lastName
      }
      let luggage = 0
      let gasFee = 0
      let tip = 0
      for (let i = 0; i < data.rsvp.length; i++) {
        luggage = luggage + data.rsvp[i].luggage
        gasFee += data.rsvp[i].gasFee
        tip += data.rsvp[i].payment.tip
      }
      let index = data.rsvp.findIndex(x => x.ID === data.stops[data.stops.length - 1].reservationID)

      if (data.rsvp.length === 0) { return false }

      let pkgData = {
        'ID': `PKG ${data.package.id}`,
        'Pickup Date': moment(data.package.pickupTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY hh:mmA'),
        'Pickup': data.package.firstPickup,
        'Pickup Sector': '',
        'Dropoff': data.rsvp[index].dropoffLocation.city,
        'Dropoff Sector': '',
        'Service': 'shared',
        'Customer': customer,
        'PAX / Luggage': `${data.package.pax} / ${data.luggage}`,
        'Flight': 'N/A',
        'Driver Payment': data.package.paidForProvider + gasFee + tip,
        'Amount': 0
      }
      if (!CONFIG.useOldQuatation) {
        pkgData.serviceType = {
          label: data.rsvp[0].serviceType.label,
          color: data.rsvp[0].serviceType.color
        }
      }
      return pkgData
    },
    getSectorData (data, rsvpIds) {
      let self = this
      self.$sdk.post('/sectors/rsvp', {
        token: self.$store.state.session.sessionToken,
        rsvpIds: rsvpIds
      }, res => {
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }

        if (Object.keys(res.rsvp).length) {
          for (let i = 0; i < data.length; i++) {
            data[i]['Pickup Sector'] = res.rsvp[data[i].ID] && res.rsvp[data[i].ID].pickup ? res.rsvp[data[i].ID].pickup.name : 'N/A'
            data[i]['Dropoff Sector'] = res.rsvp[data[i].ID] && res.rsvp[data[i].ID].dropoff ? res.rsvp[data[i].ID].dropoff.name : 'N/A'
          }
        }

        data.push({
          'ID': 'TOTAL',
          'Pickup Date': '',
          'Pickup': '',
          'Pickup Sector': '',
          'Dropoff': '',
          'Dropoff Sector': '',
          'Service': '',
          'Customer': '',
          'PAX / Luggage': '',
          'Flight': '',
          'Driver Payment': parseFloat(self.total.driverPayment.toFixed(2)),
          'Fare': parseFloat(self.total.fare.toFixed(2))
        })

        let from = self.from ? moment(self.from).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        let to = self.to ? moment(self.to).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        const exporter = CsvExport.create({
          filename: `prov${self.provId}_${from}_${to}.csv`,
          columns: [
            'ID', 'Pickup Date', 'Pickup', 'Pickup Sector', 
            'Dropoff', 'Dropoff Sector', 'Service',
            'Customer', 'PAX / Luggage', 'Flight',
            'Driver Payment', 'Fare'
          ]
        })
        exporter.downloadCsv(data)
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
      })
    }
  },
  watch: {
    provId: function (value) {
      if (this.active && this.loaded !== value) {
        this.init()
      }
    },
    active (val) {
      if (val && this.loaded !== this.provId) {
        this.init()
      }
    }
  },
  mounted () {
    // this.init()
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.range{
  margin-bottom: 20px;
  display: flex;
  .data-field{
    display: inline-block;
    width: 40%;
  }
  .export-box{
    width: 20%;
    padding-top: 17px;
  }
}
.data-field{
  padding-right: 10px;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;
  }
  .datepicker{ position: relative }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0 50px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;
    text-align: center;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        a{ font-weight: 600; }
        &.pkg{ color: #0d79f2; }
        &.date{
          width: 160px;
          color: #888;
        }
        &.service, &.hudson{ width: 120px; }
        &.pax-luggage{ width: 60px; }
        &.flight{ width: 70px; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

.service-label{
  line-height: 24px;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  text-transform: capitalize;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}

.hideMobile, .hideDesktop {
  display: none;
}

@media only screen and (max-width: 430px) {
  .table-card {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    font-size: 13px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .time {
        font-size: 12px;
        color: #777;
        word-spacing: 5px;
      }

      .amount {
        font-weight: 900;
        font-size: 20px;
        a {
          text-decoration: none;
        }
      }

      .service-div {
        display: flex;
        .service {
          margin-left: 10px;
        }
      }
    }

    .clock {
      i {
        color: #F25E0D;
      }
      span {
        font-size: 13px;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }

    .flight {
      i {
        color: #187f07;
      }
    }

    .name {
      i {
        color: #0d79f2;
      }
    }

  }
  .table-block{
    padding: 20px 15px;
    font-size: 20px;
    color: #777;
    font-weight: 600;
    font-style: italic;
    text-align: center;

    .fa{
      color: #ccc;
    }
  }
  .icon {
    color: dimgray;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/Reservations.vue